import actionTypes from './actionTypes';
import enforceNotificationStructure from 'src/utils/dataStructure/enforceNotificationStructure';
import api, { createAuthenticatedApiInstance } from 'src/utils/api';
import { setAlert } from 'src/modules/shared/alert/actions';
import i18n from 'i18next';
import * as log from 'loglevel';

export const fetchCurrentUser = () => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.FETCH_CURRENT_USER });
    try {
      const api = createAuthenticatedApiInstance(getState);
      const response = await api.get('private/user/current');
      return dispatch({
        type: actionTypes.FETCH_CURRENT_USER_SUCCESS,
        user: response.data,
      });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: actionTypes.FETCH_CURRENT_USER_FAILURE });
    }
  };
};

export const fetchCurrentCommunity = (slug) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.FETCH_CURRENT_COMMUNITY });
    try {
      const state = getState();
      const currentUser = state.context.currentUser;
      const isMember = !!currentUser
        && !!currentUser.followedCommunities.find(x => x.slug === slug);
      const api = createAuthenticatedApiInstance(getState);
      const { data } = !isMember
        ? await api.getPublic(`communities/${slug}`)
        : await api.get(`private/communities/${slug}`);
      return dispatch({
        type: actionTypes.FETCH_CURRENT_COMMUNITY_SUCCESS,
        community: data,
      });
    } catch (ex) {
      const statusCode = ex.response && ex.response.status
        ? ex.response.status
        : null;

      if (statusCode !== 314) { // temporary hack to avoid logging when redirecting to BG
        log.error(ex);
      }

      return dispatch({
        type: actionTypes.FETCH_CURRENT_COMMUNITY_FAILURE,
        statusCode,
      });
    }
  };
};

export const fetchPermissions = (communityId) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.FETCH_PERMISSIONS });
    try {
      const { context: { currentUser } } = getState();
      const api = createAuthenticatedApiInstance(getState);
      const { data: { permissions, roles } } = await api.get(`private/users/${currentUser.userId}/permissions`, {
        params: { communityId },
      });
      dispatch({
        type: actionTypes.FETCH_PERMISSIONS_SUCCESS,
        permissions,
        roles,
      });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: actionTypes.FETCH_PERMISSIONS_FAILURE });
    }
  };
};

export const fetchUnreadMessagesCount = () => {
  return async (dispatch) => {
    dispatch({ type: actionTypes.FETCH_UNREAD_MESSAGES_COUNT });

    try {
      const response = await api.auroraGet('messages/unread-count');
      const { data: { payload: { unreadMessages } = {}, status } } = response;

      if (status && !status.success) {
        return dispatch({ type: actionTypes.FETCH_UNREAD_MESSAGES_COUNT_FAILURE });
      }

      dispatch({ type: actionTypes.FETCH_UNREAD_MESSAGES_COUNT_SUCCESS, count: unreadMessages });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: actionTypes.FETCH_UNREAD_MESSAGES_COUNT_FAILURE });
    }
  };
};

export const fetchUnreadNotificationsCount = () => {
  return async (dispatch) => {
    dispatch({ type: actionTypes.FETCH_UNREAD_NOTIFICATIONS_COUNT });

    try {
      const response = await api.auroraGet('notifications/unread');
      const { data: { payload: { unread } = {}, status } } = response;

      if (status && !status.success) {
        return dispatch({ type: actionTypes.FETCH_UNREAD_NOTIFICATIONS_COUNT_FAILURE });
      }

      dispatch({ type: actionTypes.FETCH_UNREAD_NOTIFICATIONS_COUNT_SUCCESS, count: unread });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: actionTypes.FETCH_UNREAD_NOTIFICATIONS_COUNT_FAILURE });
    }
  };
};

export const fetchNotifications = () => {
  return async (dispatch) => {
    dispatch({ type: actionTypes.FETCH_NOTIFICATIONS });

    try {
      const response = await api.auroraGet('notifications/items', {
        params: {
          size: 5,
          markread: true,
          from: 0,
        },
      });
      const { data: { payload: { notifications: notificationData, users, groups } = {}, status } } = response;

      if (status && !status.success) {
        return dispatch({ type: actionTypes.FETCH_NOTIFICATIONS_FAILURE });
      }

      const notifications = notificationData.map(n => enforceNotificationStructure(n, users, groups));
      dispatch({ type: actionTypes.FETCH_NOTIFICATIONS_SUCCESS, notifications });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: actionTypes.FETCH_NOTIFICATIONS_FAILURE });
    }
  };
};

export const updateLanguage = (lang) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.UPDATE_LANGUAGE });
    try {
      const state = getState();
      const currentUser = state.context.currentUser;
      if (!!currentUser) {
        const response = await api.auroraPut('account/language', { userId: currentUser.userId, lang });
        const { data: { status } } = response;

        if (status && !status.success) {
          dispatch(setAlert(status.message, 'danger', false));
          return dispatch({ type: actionTypes.UPDATE_LANGUAGE_FAILURE });
        }
      }

      dispatch({ type: actionTypes.UPDATE_LANGUAGE_SUCCESS });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: actionTypes.UPDATE_LANGUAGE_FAILURE });
    }
  };
};

export const resendVerificationLink = () => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.RESEND_VERIFICATION_LINK });
    try {
      await api.auroraPost('profile/resend-verification-link');
      dispatch(setAlert(i18n.t('Verification email sent!'), 'success'));
      dispatch({ type: actionTypes.RESEND_VERIFICATION_LINK_SUCCESS });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: actionTypes.RESEND_VERIFICATION_LINK_FAILURE });
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/shared/context/actions.js